import {userStore} from '../stores/userStore';
import {leerplatformSettingsStore} from '../stores/leerplatformSettingsStore';
import {settingsStore} from '@/stores/settingsStore';

export const updateUserDetails = async (): Promise<void> => {
    const portalApiUrl = settingsStore.portalApiUrl;

    if (!portalApiUrl) {
        throw new Error('portalApiUrl is required');
    }

    const accessToken = userStore.accessToken;

    if (!accessToken) {
        throw new Error('No access token available');
    }

    const response = await fetch(`${portalApiUrl}/api/1.0/UpdateUserDetails`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        throw new Error(`Failed to update user details: ${response.statusText}`);
    }
};

export const updateUserDetailsCentral = async (): Promise<void> => {
    const academyDepartmentsUrl = leerplatformSettingsStore.getAcademyDepartmentsUrl;
    const portalIdentifier = settingsStore.portalIdentifier;

    if (!academyDepartmentsUrl || !portalIdentifier) {
        throw new Error('academyDepartmentsUrl and portalIdentifier are required');
    }

    const accessToken = userStore.accessToken;

    if (!accessToken) {
        throw new Error('No access token available');
    }

    const response = await fetch(
        `${academyDepartmentsUrl}/api/1.0/notifyLogon/${portalIdentifier}`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
        },
    );

    if (!response.ok) {
        throw new Error(`Failed to update user details central: ${response.statusText}`);
    }
};
